import { Injectable, inject } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {map} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {ToastrService} from 'ngx-toastr';
import {AccessService} from './access.service';
import {LocalStorageService} from "./local-storage.service";
import {Router} from "@angular/router";

@Injectable({
    providedIn: 'root'
})
export class DataService {
    private http = inject(HttpClient);
    private toastrService = inject(ToastrService);
    private accessService = inject(AccessService);
    private localStorageService = inject(LocalStorageService);
    private router = inject(Router);


    request(action: string, dataObject: object = null): Observable<any> {

        return this.http
            .post('api/api.php', {
                action,
                data: dataObject,
            }, {
                headers: {"Authorization": this.accessService.token}
            })
            .pipe(
                map((response: any) => {
                    if (response?.errors) {
                        response.errors.forEach(error => {
                            this.toastrService.error(error, 'Fehler');
                        });
                    }

                    if (response?.invalid_token) {
                        this.localStorageService.removeItem('token');
                        this.accessService.token = '';
                        this.accessService.user = null;
                        this.router.navigate(['/login']);
                    }

                    return response;
                })
            );
    }
}




